import { render } from "./friendlyIndex.vue?vue&type=template&id=e4ef8e46"
import script from "./friendlyIndex.vue?vue&type=script&lang=js"
export * from "./friendlyIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__